import { Route } from "react-router-dom";

import Documents from "../pages/Documents";

export const documents = <Route path="documents" element={<Documents />} />;
